import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Spinner,
  Input,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import { FaDownload, FaCopy } from "react-icons/fa";
import { getSurveyQRCode } from "../../../helpers/surveyApi";
import { successMessage, dangerMessage } from "../../Toast/Toast";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Label } from "reactstrap";

const SurveyQRCode = ({ surveyId, surveyTitle, token, onClose }) => {
  const [qrCode, setQrCode] = useState(null);
  const [surveyUrl, setSurveyUrl] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchQRCode();
  }, [surveyId]);

  const fetchQRCode = async () => {
    setIsLoading(true);
    try {
      const result = await getSurveyQRCode(surveyId, token);
      if (result?.status === "success") {
        setQrCode(result.data?.qrCode);
        setSurveyUrl(result.data?.surveyUrl || "");
      } else {
        dangerMessage(result?.message || "Failed to load QR code");
      }
    } catch (error) {
      dangerMessage("Error loading QR code");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownload = () => {
    if (!qrCode) return;

    try {
      // Create a link element and trigger download
      const link = document.createElement("a");
      link.href = qrCode;
      link.download = `survey-${surveyTitle || "qr-code"}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      successMessage("QR code downloaded successfully");
    } catch (error) {
      dangerMessage("Failed to download QR code");
      console.error(error);
    }
  };

  const handleCopyLink = () => {
    successMessage("Link copied to clipboard!");
  };

  return (
    <div className="p-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h3>Survey QR Code</h3>
        <Button color="secondary" onClick={onClose}>
          Close
        </Button>
      </div>

      <Card>
        <CardHeader>
          <h5 className="mb-0">{surveyTitle}</h5>
        </CardHeader>
        <CardBody>
          {isLoading ? (
            <div className="d-flex justify-content-center align-items-center p-5">
              <Spinner color="primary" />
            </div>
          ) : qrCode ? (
            <div className="text-center">
              <div className="mb-4">
                <img
                  src={qrCode}
                  alt="Survey QR Code"
                  style={{
                    maxWidth: "400px",
                    width: "100%",
                    height: "auto",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    padding: "20px",
                    backgroundColor: "#fff",
                  }}
                />
              </div>

              {surveyUrl && (
                <div className="mb-4">
                  <Label className="mb-2">Survey URL</Label>
                  <InputGroup>
                    <Input
                      type="text"
                      value={surveyUrl}
                      readOnly
                      style={{ backgroundColor: "#f8f9fa" }}
                    />
                    <InputGroupText>
                      <CopyToClipboard text={surveyUrl} onCopy={handleCopyLink}>
                        <Button color="link" className="p-0">
                          <FaCopy />
                        </Button>
                      </CopyToClipboard>
                    </InputGroupText>
                  </InputGroup>
                </div>
              )}

              <div className="d-flex justify-content-center gap-2">
                <Button color="primary" onClick={handleDownload}>
                  <FaDownload className="me-2" />
                  Download QR Code
                </Button>
                {surveyUrl && (
                  <CopyToClipboard text={surveyUrl} onCopy={handleCopyLink}>
                    <Button color="info">
                      <FaCopy className="me-2" />
                      Copy Link
                    </Button>
                  </CopyToClipboard>
                )}
              </div>
            </div>
          ) : (
            <div className="text-center p-5">
              <p className="text-muted">No QR code available</p>
            </div>
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default SurveyQRCode;
